import { SplashHeader } from '../../pages/Login/SplashHeader';
import QuickStartGuide from './QuickStartGuide';
import SplashFooter from '../../pages/Login/SplashFooter';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var UnAuthedQuickStartGuide = function () { return /*#__PURE__*/ _jsxs("div", { children: [/*#__PURE__*/ _jsx(SplashHeader, {}), /*#__PURE__*/ _jsx(QuickStartGuide, {}), /*#__PURE__*/ _jsx(SplashFooter, {})] }); };
